import React, { useEffect } from 'react';
import { Box, Typography, Button, Card, CardContent, Divider } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { containerBg, pageGradient } from '../styles/theme';

// Example past quizzes data (replace with real data source as needed)
const pastQuizzes = [
  { id: '2024-05-11', date: 'May 11, 2024' },
  { id: '2024-05-04', date: 'May 4, 2024' },
  { id: '2024-04-27', date: 'April 27, 2024' },
];

const Home: React.FC = () => {
  const navigate = useNavigate();

  useEffect(() => {
    document.body.style.background = pageGradient;
    document.body.style.minHeight = "100vh";
    return () => {
      document.body.style.background = "";
      document.body.style.minHeight = "";
    };
  }, []);

  return (
    <Box
      maxWidth={500}
      mx="auto"
      p={4}
      sx={{
        background: containerBg,
        minHeight: '60vh',
        borderRadius: 6,
        boxShadow: 6,
        mt: 10,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
      }}
    >
      <Typography
        variant="h2"
        sx={{
          fontFamily: '"Baloo 2", Arial, sans-serif',
          fontWeight: 700,
          letterSpacing: 2,
          color: 'primary.main',
          textAlign: 'center',
          mb: 3,
          textShadow: '1px 2px 8px #fffbe6'
        }}
      >
        Welcome to Quiz Time!
      </Typography>
      <Button
        variant="contained"
        color="primary"
        size="large"
        sx={{
          fontWeight: 700,
          borderRadius: 4,
          px: 5,
          py: 1.5,
          fontFamily: '"Baloo 2", Arial, sans-serif',
          mb: 4,
        }}
        onClick={() => navigate('/quiz')}
      >
        Start This Week's Quiz
      </Button>
      <Divider sx={{ width: '100%', my: 3 }} />
      <Typography
        variant="h5"
        sx={{
          fontFamily: '"Baloo 2", Arial, sans-serif',
          fontWeight: 600,
          color: '#800020', // burgundy
          mb: 2,
        }}
      >
        Old Stuff
      </Typography>
      <Box width="100%">
        {pastQuizzes.length === 0 ? (
          <Typography color="text.secondary" sx={{ textAlign: 'center', fontFamily: '"Baloo 2", Arial, sans-serif' }}>
            No past quizzes yet!
          </Typography>
        ) : (
          pastQuizzes.map((quiz) => (
            <Card
              key={quiz.id}
              variant="outlined"
              sx={{
                mb: 2,
                borderRadius: 3,
                boxShadow: 1,
                background: '#fffbe6',
                cursor: 'pointer',
                transition: 'box-shadow 0.2s',
                '&:hover': { boxShadow: 4 },
              }}
              onClick={() => navigate(`/quiz/${quiz.id}`)}
            >
              <CardContent sx={{ py: 2 }}>
                <Typography
                  variant="subtitle1"
                  sx={{
                    fontFamily: '"Baloo 2", Arial, sans-serif',
                    fontWeight: 600,
                    color: '#800020', // burgundy for quiz date
                  }}
                >
                  {quiz.date}
                </Typography>
              </CardContent>
            </Card>
          ))
        )}
      </Box>
    </Box>
  );
};

export default Home;